<template>
  <v-card
    class="mx-auto"
    width="800"
  >
    <v-card-title class="title font-weight-regular justify-space-between">
      <span><v-icon color="primary">help_outline</v-icon>{{ currentTitle }}</span>
      <v-avatar
        color="primary lighten-2"
        class="subheading white--text"
        size="24"
        v-text="step"
      ></v-avatar>
    </v-card-title>

    <v-window v-model="step">

      <v-window-item :value="1">
        <v-card-title primary-title>
            <div>
              <v-icon color="primary"> dashboard</v-icon>
              {{ inicio }}
              <br>
              {{ estadisticas }}
            </div>
        </v-card-title>
      </v-window-item>

      <v-window-item :value="2">
        <v-card-title primary-title>
              <v-container>
                <v-layout align-center justify-center row wrap fill-height>
                  <v-flex xs12>
                    <v-icon color="primary">description</v-icon>
                      {{ nueva_actuacion }}
                  </v-flex>
                  <v-flex xs12 md6>
                    <h3>Formulario inicial</h3>
                    <ul>
                      <li>RIF</li>
                      <li>Nombre del Cliente / Razón Social</li>
                      <li>Tipo de Actuación</li>
                      <li>Indicar el número de páginas</li>
                      <li>Fecha de la actuación</li>
                      <li>Monto del activo</li>
                      <li>Finalidad o propósito de la actuación</li>
                      <li>Hojas de seridad en caso de usarlas</li>
                    </ul>
                  </v-flex>
                  <v-flex xs12 md6>
                    <h3>Requerimientos por tipo de actuación</h3>
                    <ul>
                      <li>Auditoría</li>
                      <li>Atestiguamiento</li>
                      <li>Compilación</li>
                      <li>Otros</li>
                    </ul>
                    <p>Según el tipo de actuación cargar los documentos que la respaldan en formato PDF con la finalidad de hacer la revisión pertinente.</p>

                  </v-flex>
                </v-layout>
              </v-container>
        </v-card-title>
      </v-window-item>

      <v-window-item :value="3">
        <v-card-title primary-title>
            <v-container>
                <v-layout align-center justify-center row wrap fill-height>
                  <v-flex xs12>
                    <v-icon color="primary">chrome_reader_mode</v-icon>
                    {{ mis_actuaciones }}
                  </v-flex>
                  <v-flex xs12>
                    <br>
                    <h3>Acciones:</h3>
                    <ul>
                      <li>Visualización del Estatus</li>
                      <li>Correcciones/Edición</li>
                      <li>Registrar Pagos</li>
                      <li>Descarga de la Actuación Profesional Protegida</li>
                    </ul>
                    <br>
                    <p>Es decir, cualquier interacción relacionada con la Actuación Profesional cargada para hacer seguimiento a la gestión
                      propia del Colegio en este proceso de protección.</p>
                  </v-flex>
                </v-layout>
              </v-container>
        </v-card-title>
      </v-window-item>

      <v-window-item :value="4">
        <v-card-title primary-title>
          <v-container>
                <v-layout align-center justify-center row wrap fill-height>
                  <v-flex xs12>
                    <v-icon color="primary">account_balance_wallet</v-icon>
                      {{ mis_pagos }}
                  </v-flex>
                  <v-flex xs12>
                    <br>
                    <h3>Acciones:</h3>
                    <ul>
                      <li>Visualización del Histórico de Pagos</li>
                    </ul>
                    <br>
                    <p>Módulo para visualizar todos los pagos realizados y conciliados por el CCPDC en el Servicio de Registro de la Actuación Profesional Electrónica del Contador Público Colegiado.</p>
                  </v-flex>
                </v-layout>
              </v-container>
        </v-card-title>
      </v-window-item>



      <v-window-item :value="5">
        <v-card-title primary-title>
            <div>
              <v-icon color="primary">help</v-icon>
              {{ ayuda }}
              </div>
        </v-card-title>
      </v-window-item>

    </v-window>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn
        :disabled="step === 1"
        flat
        @click="step--"
      >
        Atras
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="step === 5"
        color="primary"
        depressed
        @click="step++"
      >
        Siguiente
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    data: () => ({
      step: 1,
        inicio: 'Bienvenida al Sistema de Registro de la Actuación Profesional Electrónica del Contador Público Colegiado RAPE.',
        estadisticas: 'Podrá visualizar un resumen por Estatus de sus actuaciones.',
        nueva_actuacion: 'Iniciar  el registro de la actuación profesional y completar formulario con los datos de la Actuación.',
        mis_actuaciones: 'Listar todas las actuaciones profesionales que el Contador Público Colegiado ha registrado en este sistema, con la finalidad de gestionarlas.',
        mis_pagos: 'Histórico de pagos debidamente conciliados por el CCPDC en cuanto al RAPE.',
        ayuda: 'Reseña básica de los diversos módulos del sistema del CCPDC.'

    }),

    computed: {
      currentTitle () {
        switch (this.step) {
          case 1: return 'Inicio'
          case 2: return 'Nueva Actuación'
          case 3: return 'Mis Actuaciones'
          case 4: return 'Mis Pagos'
          default: return 'Ayuda al Agremiado'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/help.vue